import React, { Component } from 'react';

import { split as _split } from 'lodash';
import PropTypes from 'prop-types';

import { withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import { TABS_LABELS } from '../BusinessOverview/Utils/Enums';
import BusinessOverviewTabbedView from '../Common/UI/BusinessOverviewTabbedView';
import { PRODUCT_STATUS } from '../Services/Enums';
import { Images } from '../Themes';
import { getThemeImages } from '../Themes/Modes/Helpers';

import styles from './ProfileManagement.Styles';

class ProfileManagement extends Component {
  constructor(props) {
    super(props);
  }

  getTabPageBannerProps(key, tabProps) {
    const images = getThemeImages();
    const { numberToReview } = tabProps;
    switch (key) {
      case TABS_LABELS.PLANS:
        return {
          title: 'soho_profile_management_cvm_page_banner_plans_title',
          description: 'soho_profile_management_cvm_page_banner_plans_description',
        };

      case TABS_LABELS.LICENCES:
        return {
          title:
            numberToReview === 1
              ? 'soho_profile_management_cvm_page_banner_licence_title_singular'
              : 'soho_profile_management_cvm_page_banner_licence_title_plural',
          description:
            numberToReview === 1
              ? 'soho_profile_management_cvm_page_banner_licence_description_singular'
              : 'soho_profile_management_cvm_page_banner_licence_description_plural',
        };

      case TABS_LABELS.ADDONS:
        return {
          title:
            numberToReview === 1
              ? 'soho_profile_management_cvm_page_banner_add_ons_title_singular'
              : 'soho_profile_management_cvm_page_banner_add_ons_title_plural',
          description:
            numberToReview === 1
              ? 'soho_profile_management_cvm_page_banner_add_ons_description_singular'
              : 'soho_profile_management_cvm_page_banner_add_ons_description_plural',
          primaryButtonTitle:
            'soho_profile_management_cvm_page_banner_add_ons_primary_button_title',
          leftIcon: images.ic_add_white,
          leftIconType: 'image',
          withLeftIcon: true,
          titleStyle: styles.pageBannerTitleStyle,
          descriptionStyle: styles.pageBannerDescriptionStyle,
          iconAndTitleContainerStyle: styles.iconAndTitleContainerStyle,
        };

      default:
        return {};
    }
  }

  getSubHeaderMaxHeight = () => {
    const { accountNo, phoneNumber } = this.props;
    if (!!phoneNumber && !!accountNo) {
      return 117;
    } else if (!!phoneNumber || !!accountNo) {
      return 87;
    } else {
      return 60;
    }
  };

  render() {
    const { userName, accountNo, phoneNumber, user, isCurrencyFirst } = this.props;
    const firstName = _split(userName, ' ')[0];
    return (
      <BusinessOverviewTabbedView
        title={'soho_profile_management_title'}
        subHeaderTitle={userName}
        subHeaderTitleStyle={styles.subHeaderTitleStyle}
        subHeaderBeforeSubTitle={accountNo ? 'soho_profile_management_account_number' : null}
        subHeaderBeforeSubTitleStyle={accountNo ? styles.subHeaderBeforeSubTitleStyle : null}
        subHeaderSubTitle={accountNo ? ` ${accountNo}` : null}
        subHeaderDescription={phoneNumber ?? null}
        subHeaderDescriptionStyle={styles.subHeaderDescriptionStyle}
        subHeaderFullContainerStyle={styles.subHeaderFullContainerStyle}
        subHeaderMaxHeight={this.getSubHeaderMaxHeight()}
        getTabPageBannerProps={this.getTabPageBannerProps}
        isCurrencyFirst={isCurrencyFirst}
        {...this.props}
        plansProps={{
          withUsers: false,
          title: 'soho_profile_plans_section_title',
          subTitle: 'soho_profile_plans_section_subtitle',
          withViewPlanButton: false,
          withUpgradePlanButton: true,
          shouldShowAddUsageButton: true,
          ...this.props.plansProps,
        }}
        addOnsProps={{
          withUsers: false,
          title: 'soho_profile_addons_table_title',
          titlePlaceHolders: [firstName],
          emptyAddOnsTitle: 'soho_addons_user_addons_empty_text',
          emptyAddOnsTitlePlaceHolders: [firstName],
          emptyActiveAddOnsTitle: 'soho_addons_user_active_addons_empty_text',
          emptyActiveAddOnsTitlePlaceHolders: [firstName],
          ...this.props.addOnsProps,
        }}
        licencesProps={{
          licencesTitle: 'soho_profile_management_user_details_licences',
          isProfileManagement: true,
          withLicenceUsage: false,
          withFilterAndSearchBars: false,
          ...this.props.licencesProps,
          applications: this.props.licencesProps.applications?.filter(
            application => application.licences[0].status === PRODUCT_STATUS.ACTIVE,
          ),
        }}
        usageProps={{
          screenConfig: {
            users: {
              title: 'soho_overtime_users_title',
              subTitle: 'soho_usage_categories_title',
              description: 'soho_usage_users_description',
            },
            categories: {
              title: 'soho_usage_categories_title',
              subTitle: 'soho_overtime_users_title',
              description: 'soho_usage_categories_description',
              icon: Images.ic_calender_red,
            },
          },
          user: user,
          withSeeAll: false,
          withFilterBar: false,
          ...this.props.usageProps,
        }}

        tabsToExclude={['BUDGET', 'SETTINGS', 'PLANS', 'ADDONS', 'DEVICES', 'LICENCES', 'USAGE']}
      />
    );
  }
}

ProfileManagement.defaultProps = {
  isCurrencyFirst: false,
};

ProfileManagement.propTypes = {
  customTabs: PropTypes.arrayOf(
    PropTypes.shape({
      index: PropTypes.number,
      platform: PropTypes.oneOf(['android', 'ios']),
      key: PropTypes.string.isRequired,
      tab_key: PropTypes.string.isRequired,
      renderTabContent: PropTypes.func.isRequired,
    }),
  ),
  onClose: PropTypes.func,
  withPageBanner: PropTypes.bool,
  pageBannerProps: PropTypes.object,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  withTray: PropTypes.bool,
  images: PropTypes.object,
  onActiveTabChange: PropTypes.func,
  vfScreenProps: PropTypes.object,
  plansProps: PropTypes.object,
  usageProps: PropTypes.object,
  licencesProps: PropTypes.object,
  devicesProps: PropTypes.object,
  addOnsProps: PropTypes.object,
  userName: PropTypes.string,
  accountNo: PropTypes.string,
  user: PropTypes.object,
  phoneNumber: PropTypes.string,
  isCurrencyFirst: PropTypes.bool,
};

export default withTheme(ProfileManagement);
